<template>
  <div>
    <v-layout row wrap justify-center class="white pa-3 set-border-all">
          <v-flex xs12>
            <v-card class="text-xs-center border-radius" v-if="subscription">
              <v-card-text class="px-0 py-5">
                <v-layout row wrap>
                  <v-flex xs12 class="pt-5">
                    <div
                      class="display-2 font-weight-bold"
                    >{{ $t("subscription.message.created.success.title") }}</div>
                    <div
                      class="headline py-3"
                    >{{ $t("subscription.message.created.success.desc_1") }}</div>
                  </v-flex>
                  <v-flex xs12>
                    <div>
                      <v-icon class="display-4" color="success">$vuetify.icons.rms_check_without_circle</v-icon>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <div class="title pt-2 pb-3">
                      {{ $t("subscription.message.created.success.desc_3",{
                        current_period_start: moment.utc(subscription.created_at).local().format("MMM D, YYYY HH:MM") })
                      }}
                    </div>
                  </v-flex>
                  <v-flex xs12 class="light-bg pa-4 my-4 border-top-bottom">
                    <div>
                      <span class="grey--text text--darken-4">{{ $t("subscription.message.created.success.desc_4") }}&nbsp;</span>
                      <span class="blue--text cursor-pointer decor-line" @click="goToConsumerDashboard()"><strong>{{ $t("subscription.message.go_to_dashboard") }}<v-icon class="blue--text" small>$vuetify.icons.rms_go_forward</v-icon></strong></span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
  </div>
</template>
  
<script>
import { mapState, mapGetters } from "vuex";
import i18n from "@/i18n";

export default {
  name: "SubscriptionSuccess",
  computed: {
    ...mapState({
      subscription: state => state.subscription.subscription
    }),
    ...mapGetters({
      currentCompanyId: "company/getCurrentCompanyId"
    })
  },
  created() {
    if(!this.subscription){
      this.$router.push({
        name: "subscription.plans"
      });
    }
  },
  methods:{
    goToConsumerDashboard(){
      return this.$router.push({
        name: "user.dashboard",
        query: {
          tab: 'subscription'
        }
      });
    }
  }
};
</script>
  
<style scoped>
.light-bg {
background: #edf2f5;
}
.border-top-bottom {
border-top: 1px solid rgba(15, 15, 15, 0.1);
border-bottom: 1px solid rgba(15, 15, 15, 0.1);
}
.set-border-all {
border: 0.5px solid #2196f3 !important;
border-radius: 7px;
}
.border-radius {
  border-radius: 7px;
}
.decor-line{
  text-decoration: underline;
}
</style>
  